import FilterCard from 'Components/Editor/Details/Filters/FilterCard';
import FilterSlider from 'Components/Editor/Details/Filters/FilterSlider';
import { DetectionConfidenceSpecification } from 'Models/Project/ProjectFilterSpecifications';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import { ReactElement } from 'react';

interface FilterCardConfidenceProps {
	confidence: DetectionConfidenceSpecification | null;
	onConfidenceChanged: (confidence: DetectionConfidenceSpecification | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const FilterCardConfidence = (props: FilterCardConfidenceProps): ReactElement => {
	const isChecked = props.confidence !== null;
	const fromValue = (props.confidence?.from ?? 0) * 100;
	const toValue = (props.confidence?.to ?? 1) * 100;

	const marks = [0, 25, 50, 75, 100].map((value) => ({
		value,
		label: `${value}%`,
	}));

	const getDefaultConfidence = (): DetectionConfidenceSpecification => {
		if (props.selectedDetections.length === 0) return { from: 0, to: 1 };

		const firstConfidence = props.selectedDetections[0].confidence;
		return props.selectedDetections.slice(1).reduce(
			(range, detection) => ({
				from: Math.min(range.from, detection.confidence),
				to: Math.max(range.to, detection.confidence),
			}),
			{ from: firstConfidence, to: firstConfidence }
		);
	};

	const handlePlacementCardCheckedChanged = (checked: boolean): void => {
		props.onConfidenceChanged(checked ? getDefaultConfidence() : null);
	};

	const handleValuesChanged = (from: number, to: number): void => {
		props.onConfidenceChanged({ from: from / 100, to: to / 100 });
	};

	return (
		<FilterCard name="Detection confidence" onCheckedChanged={handlePlacementCardCheckedChanged} isChecked={isChecked}>
			{' '}
			sdfafaf
			<FilterSlider
				label="Detection confidence"
				fromValue={fromValue}
				toValue={toValue}
				min={0}
				max={100}
				step={1}
				marks={marks}
				valueLabelFormat={(value) => `${value}%`}
				onValuesChanged={handleValuesChanged}
			/>
		</FilterCard>
	);
};

export default FilterCardConfidence;
